var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[
    'svg-icon',
    _vm.shit$("pointer-events: none; vertical-align: middle; display: inline-block"),
    _vm.shit$(("fill:" + (_vm.color || '#c1c1c1') + "; stroke: " + (_vm.stroke || '') + ";")),
    _vm.active && _vm.shit$("fill:#00b5e2; stroke:#00b5e2;"),
    _vm.shit && _vm.shit$(_vm.shit)
  ],attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"xlink:href":_vm.href}})])}
var staticRenderFns = []

export { render, staticRenderFns }